/**
 * Who reaches Settings › Data Maintenance and what they see there.
 *
 *   - useCanSeeLandAreaMismatches: the Land area mismatch list (decision 21, LAND-MISMATCH-b) —
 *     Super Admin, Admin and Research, the API's requireResearchOrAdminRole on
 *     GET /api/data-maintenance/land-area-mismatches (RESEARCH_OR_ADMIN_ROLES, primary role).
 *     The fix is the normal property save, which Research already makes (useCanEditProperty).
 *   - useCanOpenDataMaintenance: the page and its Settings card — feature:settings_data_maintenance
 *     (the county operations, as before) or the land list.
 *
 * The other reports on the page stay admin-only (isAdmin, the API's requireAdminRole).
 * The API decides every call itself; this is UX, not security.
 */
import { RESEARCH_OR_ADMIN_ROLES } from '@aiga/app-config/permissions';
import { useAuth } from '@/contexts/AuthContext';
import { useFeatureAccess } from '@/hooks/useFeatureAccess';

export function useCanSeeLandAreaMismatches(): boolean {
  const { role } = useAuth();
  return !!role?.name && RESEARCH_OR_ADMIN_ROLES.has(role.name);
}

export function useCanOpenDataMaintenance(): boolean {
  const canRunCountyOperations = useFeatureAccess('settings_data_maintenance');
  const canSeeLandList = useCanSeeLandAreaMismatches();
  return canRunCountyOperations || canSeeLandList;
}
